import { DashboardWidgetWidth } from '@/components/dashboard/model';
import {
  networkDashboardDocumentSchema,
  NetworkDashboardSection,
  NetworkDashboardWidgetType,
} from '../../admin/networks/dashboard/widgetModel';
import { DashboardDateScopeMode, DashboardMetric } from '../../dashboard/model';

const inherit = { mode: DashboardDateScopeMode.Inherit } as const;

export const defaultPublisherDetailsDashboardDocument = networkDashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    metric('publisher-details-ad-requests', DashboardMetric.AdRequests),
    metric('publisher-details-ad-impressions', DashboardMetric.AdImpressions),
    metric('publisher-details-revenue', DashboardMetric.Revenue),
    metric('publisher-details-profit', DashboardMetric.Profit),
    {
      id: 'publisher-details-performance',
      type: NetworkDashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      metrics: [
        DashboardMetric.AdRequests,
        DashboardMetric.AdImpressions,
        DashboardMetric.FillRate,
        DashboardMetric.Rpm,
        DashboardMetric.Revenue,
        DashboardMetric.PublisherRevenue,
        DashboardMetric.Profit,
      ],
    },
    {
      id: 'publisher-details-performance-tables',
      type: NetworkDashboardWidgetType.PerformanceTables,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      pageSize: 10,
    },
    {
      id: 'publisher-details-demand-sources-heading',
      type: NetworkDashboardWidgetType.SectionHeading,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      section: NetworkDashboardSection.DemandSources,
    },
    distribution(
      'publisher-details-revenue-distribution',
      NetworkDashboardWidgetType.RevenueDistribution,
    ),
    distribution(
      'publisher-details-won-bids-distribution',
      NetworkDashboardWidgetType.WonBidsDistribution,
    ),
    {
      id: 'publisher-details-demand-performance',
      type: NetworkDashboardWidgetType.DemandPerformance,
      width: DashboardWidgetWidth.Third,
      dateScope: inherit,
      pageSize: 5,
    },
  ],
});

function metric(id: string, metricValue: DashboardMetric) {
  return {
    id,
    type: NetworkDashboardWidgetType.Metric,
    width: DashboardWidgetWidth.Quarter,
    dateScope: inherit,
    metric: metricValue,
  };
}

function distribution(id: string, type: NetworkDashboardWidgetType) {
  return { id, type, width: DashboardWidgetWidth.Third, dateScope: inherit };
}
